export const helpButtonPaths = [
  {
    match: (path: string) => path.startsWith('/authoring/upload-manuscript'),
    tour: 'authoring' as const,
  },
  {
    match: (path: string) =>
      path.startsWith('/authoring/manu~') &&
      !path.includes('/reviews') &&
      !path.includes('/proofing') &&
      !path.includes('/add-reviewers') &&
      !path.includes('/publish'),
    tour: 'authoring' as const,
  },
  {
    match: (path: string) => path.startsWith('/reviews'),
    tour: 'reviews' as const,
  },
  {
    match: (path: string) => path.startsWith('/reviewing'),
    tour: 'reviewing' as const,
  },
];
